import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router";
// @mui
import {
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import Chart from "react-apexcharts";

// components
import { useSettingsContext } from "../components/settings";

// Redux

// routes
import Iconify from "../components/iconify";
import { useSnackbar } from "../components/snackbar";
import { PATH_AUTH, PATH_DASHBOARD } from "../routes/paths";

// sections
import { AppWidgetSummary } from "../sections/general";

import { useAuthContext } from "../auth/useAuthContext";
// assets
// ----------------------------------------------------------------------

export default function LandingPage() {
  const { logout } = useAuthContext();

  const { enqueueSnackbar } = useSnackbar();

  const navigate = useNavigate();

  const { themeStretch } = useSettingsContext();

  const handleLogout = async () => {
    try {
      logout();
      navigate(PATH_AUTH.login, { replace: true });
    } catch (error) {
      enqueueSnackbar("Unable to logout!", { variant: "error" });
    }
  };

  const chartData = [
    { name: "Jan", value: 400 },
    { name: "Feb", value: 300 },
    { name: "Mar", value: 600 },
    { name: "Apr", value: 400 },
    { name: "May", value: 700 },
    { name: "Jun", value: 900 },
  ];

  const lineChartOptions = {
    chart: {
      id: "line-chart",
      toolbar: {
        show: false,
      },
    },
    xaxis: {
      categories: chartData.map((data) => data.name),
    },
  };

  const barChartOptions = {
    chart: {
      id: "bar-chart",
      toolbar: {
        show: false,
      },
    },
    xaxis: {
      categories: chartData.map((data) => data.name),
    },
  };

  const areaChartOptions = {
    chart: {
      id: "area-chart",
      toolbar: {
        show: false,
      },
    },
    xaxis: {
      categories: chartData.map((data) => data.name),
    },
  };

  const pieChartOptions = {
    labels: chartData.map((data) => data.name),
  };

  return (
    <>
      <Helmet>
        <title> Home | Carnation Dashboard</title>
      </Helmet>

      <Container maxWidth={themeStretch ? false : "xl"}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography sx={{ mb: 4 }} variant="h4" gutterBottom>
            Dashboard
          </Typography>

          <Button
            variant="contained"
            onClick={handleLogout}
            style={{ cursor: "pointer", marginTop: 35, marginBottom: 35 }}
            startIcon={<Iconify icon="eva:log-out-outline" />}
          >
            Logout
          </Button>
        </div>

        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <AppWidgetSummary
              link={PATH_DASHBOARD.entries.schools.list}
              title="Total Schools"
              total={100}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <AppWidgetSummary
              link={PATH_DASHBOARD.products.list}
              title="Total Products"
              total={100}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <AppWidgetSummary
              link={`${PATH_DASHBOARD.orders.list}`}
              title="Total Orders"
              total={100}
            />
          </Grid>
          <Grid item xs={6} md={6}>
            <Card>
              <CardContent>
                <Chart
                  options={lineChartOptions}
                  series={[{ data: chartData.map((data) => data.value) }]}
                  type="line"
                  width="100%"
                />
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={6} md={6}>
            <Card>
              <CardContent>
                <Chart
                  options={barChartOptions}
                  series={[{ data: chartData.map((data) => data.value) }]}
                  type="bar"
                  width="100%"
                />
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={6} md={6}>
            <Card>
              <CardContent>
                <Chart
                  options={areaChartOptions}
                  series={[{ data: chartData.map((data) => data.value) }]}
                  type="area"
                  width="100%"
                />
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={6} md={6}>
            <Card>
              <CardContent>
                <Chart
                  options={pieChartOptions}
                  series={chartData.map((data) => data.value)}
                  type="pie"
                  width="100%"
                />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
